const roomCollator = new Intl.Collator("pt-BR", {
  numeric: true,
  sensitivity: "base"
});

const normalizeRoomField = value =>
  value === null || value === undefined ? "" : String(value).trim();

export const compareRoomsByBlockAndName = (a, b) => {
  const blockComparison = roomCollator.compare(
    normalizeRoomField(a?.bloco),
    normalizeRoomField(b?.bloco)
  );

  if (blockComparison !== 0) return blockComparison;

  return roomCollator.compare(
    normalizeRoomField(a?.nome),
    normalizeRoomField(b?.nome)
  );
};

export const sortRoomsByBlockAndName = (rooms = []) =>
  [...rooms].sort(compareRoomsByBlockAndName);